/**
 * `POST /api/stripe/connect/dashboard-link` — mint a single-use Stripe
 * Connect login link the seller can open in a new tab to manage their
 * account (Express dashboard equivalent).
 *
 * @see app/api/stripe/connect/dashboard-link/route.ts — handler
 */

import { z } from "zod";
import { pinned } from "./pin";

export interface StripeConnectDashboardLinkResponse {
  url: string;
}

export const StripeConnectDashboardLinkResponseSchema =
  pinned<StripeConnectDashboardLinkResponse>()(
    z.object({
      url: z.url(),
    }),
  );
